import React from 'react';

const stroke = (color, strokeWidth) => ({
  stroke: color,
  strokeWidth,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  fill: 'none',
});

export const CalendarIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="M8 2v3" {...stroke(color, strokeWidth)} />
    <path d="M16 2v3" {...stroke(color, strokeWidth)} />
    <rect x="3" y="3" width="18" height="18" rx="2" {...stroke(color, strokeWidth)} />
    <path d="M3 9h18" {...stroke(color, strokeWidth)} />
  </svg>
);

export const ClockIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" {...stroke(color, strokeWidth)} />
    <path d="M12 6v6l4 2" {...stroke(color, strokeWidth)} />
  </svg>
);

export const BadgeCheckIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"
      {...stroke(color, strokeWidth)}
    />
    <path d="m9 12 2 2 4-4" {...stroke(color, strokeWidth)} />
  </svg>
);

export const ArmchairIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3" {...stroke(color, strokeWidth)} />
    <path
      d="M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z"
      {...stroke(color, strokeWidth)}
    />
    <path d="M5 18v2" {...stroke(color, strokeWidth)} />
    <path d="M19 18v2" {...stroke(color, strokeWidth)} />
  </svg>
);

export const UserPlusIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...stroke(color, strokeWidth)} />
    <circle cx="9" cy="7" r="4" {...stroke(color, strokeWidth)} />
    <line x1="19" x2="19" y1="8" y2="14" {...stroke(color, strokeWidth)} />
    <line x1="22" x2="16" y1="11" y2="11" {...stroke(color, strokeWidth)} />
  </svg>
);

export const UsersIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="M16 21v-2a4 4 0 0 0-3-3.87" {...stroke(color, strokeWidth)} />
    <path d="M2 21v-2a4 4 0 0 1 7-3.06" {...stroke(color, strokeWidth)} />
    <circle cx="9" cy="7" r="4" {...stroke(color, strokeWidth)} />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" {...stroke(color, strokeWidth)} />
  </svg>
);

export const InfoIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" {...stroke(color, strokeWidth)} />
    <path d="M12 16v-4" {...stroke(color, strokeWidth)} />
    <path d="M12 8h.01" {...stroke(color, strokeWidth)} />
  </svg>
);

export const ChevronRightIcon = ({ size = 20, color = '#B6B8CE', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="m9 18 6-6-6-6" {...stroke(color, strokeWidth)} />
  </svg>
);

export const ChevronDownIcon = ({ size = 20, color = '#B6B8CE', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="m6 9 6 6 6-6" {...stroke(color, strokeWidth)} />
  </svg>
);

export const DownloadIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path d="M12 3v12" {...stroke(color, strokeWidth)} />
    <path d="m7 11 5 5 5-5" {...stroke(color, strokeWidth)} />
    <path d="M4 19h16" {...stroke(color, strokeWidth)} />
  </svg>
);

export const TicketIcon = ({ size = 20, color = '#6FA22E', strokeWidth = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"
      {...stroke(color, strokeWidth)}
    />
    <path d="M13 5v2" {...stroke(color, strokeWidth)} />
    <path d="M13 17v2" {...stroke(color, strokeWidth)} />
    <path d="M13 11v2" {...stroke(color, strokeWidth)} />
  </svg>
);
